import { motion, AnimatePresence } from "framer-motion";

const dots = Array.from({ length: 18 }, (_, i) => i);

export function Celebrate({ open, onClose, title = "You did it. Go rest.", sub = "Taking a break is caregiving, too." }) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="celebration-overlay"
          className="fixed inset-0 z-50 flex items-center justify-center bg-hf-green/95 px-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          {dots.map((i) => (
            <motion.span
              key={i}
              className="absolute h-3 w-3 rounded-full"
              style={{ background: i % 3 === 0 ? "var(--hf-coral)" : i % 3 === 1 ? "var(--hf-sun)" : "var(--hf-cream)" }}
              initial={{ x: 0, y: 0, opacity: 1 }}
              animate={{ x: Math.cos(i) * (120 + (i % 4) * 40), y: Math.sin(i) * (120 + (i % 5) * 30), opacity: 0 }}
              transition={{ duration: 1.6, ease: "easeOut" }}
            />
          ))}
          <motion.div initial={{ scale: 0.9, y: 20 }} animate={{ scale: 1, y: 0 }} className="relative max-w-sm text-center text-hf-cream">
            <h2 className="font-heading text-4xl font-semibold leading-tight">{title}</h2>
            <p className="mt-4 text-xl text-hf-cream/85">{sub}</p>
            <button data-testid="celebration-close" onClick={onClose} className="hf-btn mt-10 w-full bg-hf-cream text-hf-green">
              Thank you
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
